import React from 'react';

import { BtnFile, LayerPopUp, BtnFileList } from 'components';
import FieldPhotoPopupContents from './FieldPhotoPopupContents';
import ProfilePopupContents from './ProfilePopupContents';
import ServicePopupContents from './ServicePopupContents';

import {
  LABEL_IMG_UPLOAD,
  LABEL_POPUP_PROFILE,
  LABEL_POPUP_FIELD_PHOTO,
  LABEL_POPUP_SERVICE_IMG,
} from 'commons/ZimssaString';
import { GUIDE_TYPE, UPLOAD_TYPE } from 'commons/ZimssaConstant';

export type TGuideType = typeof GUIDE_TYPE[keyof typeof GUIDE_TYPE];
export type TUploadType = typeof UPLOAD_TYPE[keyof typeof UPLOAD_TYPE];

export interface Props {
  type: TGuideType;
  uploadType?: TUploadType;
  inputName: string;
  imgDir: string;
  isShow: boolean;
  onClickPopupAction: () => void;
  onChangeHandler?: (type: any, value: string, imgName?: string) => void;
  onChangeMultiHandler?: (inputRef: React.RefObject<HTMLInputElement>, imgDir: string) => void;
}

function ImageGuide({
  type: guideType,
  uploadType = UPLOAD_TYPE.SINGLE,
  inputName,
  imgDir,
  isShow,
  onClickPopupAction,
  onChangeHandler,
  onChangeMultiHandler,
}: Props): React.ReactElement {
  const LayerPopUpProps = {
    width: 474,
    isShow: isShow,
    onClickPopupAction: onClickPopupAction,
    buttons: uploadType === UPLOAD_TYPE.SINGLE ? (
      <BtnFile
        inputName={inputName}
        imgDir={imgDir}
        onChangeHandler={onChangeHandler}
      >
        {LABEL_IMG_UPLOAD}
      </BtnFile>
    ) : (
      <BtnFileList
        inputName={inputName}
        imgDir={imgDir}
        onChangeHandler={onChangeMultiHandler}
      >
        {LABEL_IMG_UPLOAD}
      </BtnFileList>
    ),
    labelProps: {
      contents: (() => {
        if (guideType === GUIDE_TYPE.FIELD_PHOTO) {
          return LABEL_POPUP_FIELD_PHOTO;
        }

        if (guideType === GUIDE_TYPE.PROFILE) {
          return LABEL_POPUP_PROFILE;
        }

        if (guideType === GUIDE_TYPE.SERVICE) {
          return LABEL_POPUP_SERVICE_IMG;
        }

        return LABEL_POPUP_PROFILE;
      })(),
      fontStyle: 'title_bold',
      color: 'gray_opacity_800',
    },
  };

  return <LayerPopUp {...LayerPopUpProps}>{(() => {
    if (guideType === GUIDE_TYPE.FIELD_PHOTO) {
      return <FieldPhotoPopupContents />;
    }

    if (guideType === GUIDE_TYPE.PROFILE) {
      return <ProfilePopupContents />;
    }

    if (guideType === GUIDE_TYPE.SERVICE) {
      return <ServicePopupContents />;
    }

    return <ProfilePopupContents />;
  })()}</LayerPopUp>;
}

export default ImageGuide;
